export default __webpack_public_path__ + "static/media/Skurup_full.a514f537.png";